module.exports = __webpack_public_path__ + "img/icon-clock-blue.318ae031.svg";